module.exports = __webpack_public_path__ + "img/2csm_Ersa-Wave-POWERFLOWULTRAXL-01-900x675_77100792d2.3acd6e24.png";